<template>
  <div class="progress-container">
    <svg viewBox="0 0 32 32">
      <circle r="16" cx="16" cy="16" :style="progressCircleClipPathAmount"/>
    </svg>
    <div class="progress-text-container">
      <p class="progress-text">{{ `${totalCompletedPosts}/${totalMilestonePosts}` }}</p>
    </div>
  </div>
</template>
<script>

export default {
  props: ['project', 'milestonePostCount', 'completedPostCount'],
  data: function () {
    return {
      totalCompletedPosts: 0,
      totalMilestonePosts: 0,
      progressCircleClipPath: ''
    }
  },
  mounted: function () {
    this.totalCompletedPosts = this.completedPostCount
    this.totalMilestonePosts = this.milestonePostCount
  },
  computed: {
    progressCircleClipPathAmount: function () {
      const progressPercentage = (this.totalCompletedPosts / this.totalMilestonePosts) * 100
      // 'stroke-dasharray' changes the amount of the circular progress bar
      if (progressPercentage === 100) {
        return ''
      } else {
        return `stroke-dasharray: ${progressPercentage} 100`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.progress-container {
  position: absolute;
  bottom: 5%;
  right: 5%;
  z-index: 4;
  height: 70px;
}
svg {
  width: 70px;
  height: 70px;
  transform: rotate(-90deg);
  background: lightgrey;
  border-radius: 50%;
  border: 3px solid #1a1a1a;
}
circle {
  fill: white;
  stroke: green;
  stroke-width: 32;
}
.progress-text-container {
  position: absolute;
  border-radius: 50%;
  height: 3.1rem;
  width: 3.1rem;
  background: #1a1a1a;
  color: white;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
